<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="ic_warning" viewBox="0 0 16 16"><circle id="타원_4973" cx="8" cy="8" r="8" style="fill:#ef4f44"/><rect id="사각형_148618" width="2" height="6" rx="1" style="fill:#ffffff" transform="translate(7 3.5)"/><circle id="타원_4974" cx="1" cy="1" r="1" style="fill:#ffffff" transform="translate(7 10.5)"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-warning',
});
</script>
